module.exports = __webpack_public_path__ + "img/search.2adb7c83.svg";